import { QueryClient } from "@tanstack/react-query";
import { ACTIVITY_TASKS_QUERY_KEY } from "@coworker/apprestructured/src/activity/hooks/useActivityData";
import { FileUploadType } from "@fixa/platform-shared/dist/fileUpload/fileUpload.type";

const TASK_TYPES_QUERY_KEY = "task-types";
const TASKS_V2_QUERY_KEY = "tasks_v2";
const UPLOADS_QUERY_KEY = "uploads";

export function getAllTaskTypesQueryKey() {
  return [TASK_TYPES_QUERY_KEY];
}

export function getTaskTypesQueryKey(ids: number[]) {
  return [TASK_TYPES_QUERY_KEY, ids.toSorted()];
}

export function invalidateTaskTypesQueries(queryClient: QueryClient) {
  return queryClient.invalidateQueries({ queryKey: [TASK_TYPES_QUERY_KEY] });
}

function getTasksQueryKey(ids: string[] | null) {
  return [TASKS_V2_QUERY_KEY, ids === null ? null : ids.toSorted()];
}

export function getTaskQueryKey(id: string | null) {
  return getTasksQueryKey(id === null ? null : [id]);
}

export function getTaskLogsQueryKey(id: string | null) {
  return [TASKS_V2_QUERY_KEY, id, "logs"];
}

export function getTaskCommentsQueryKey(id: string | null) {
  return [TASKS_V2_QUERY_KEY, id, "comments"];
}

export function getTaskImagesQueryKey(id: string | null) {
  return [TASKS_V2_QUERY_KEY, id, "images"];
}

export function getTaskCommentsImagesQueryKey(id: string | null) {
  return [TASKS_V2_QUERY_KEY, id, "comments", "images"];
}

export function invalidateTaskQueries(queryClient: QueryClient) {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: [TASKS_V2_QUERY_KEY] }),
    queryClient.invalidateQueries({ queryKey: [ACTIVITY_TASKS_QUERY_KEY] }),
  ]);
}

export function getWriteSignedUrlsQueryKey(
  fileNames: string[],
  uploadType: FileUploadType
) {
  return [
    UPLOADS_QUERY_KEY,
    "write-signed-urls",
    { fileNames: fileNames.toSorted(), uploadType },
  ];
}

export function getUploadFileQueryKey(uploadId: string) {
  return [UPLOADS_QUERY_KEY, uploadId, "file"];
}
